import React from 'react'
import PropTypes from 'prop-types'
import { HiOutlineDatabase } from 'react-icons/hi'

const EmptyTableState = ({
    title = 'No data found',
    description = 'It seems there is no data to display at the moment.',
    icon = <HiOutlineDatabase className="text-6xl text-gray-300" />,
    children,
}) => {
    return (
        <div className="flex flex-col items-center justify-center p-10 text-center">
            <div className="mb-4">{icon}</div>
            <h5 className="mb-2 font-semibold text-gray-700">{title}</h5>
            <p className="max-w-[300px] text-gray-500 mb-6">{description}</p>
            {children}
        </div>
    )
}

EmptyTableState.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    icon: PropTypes.node,
    children: PropTypes.node,
}

export default EmptyTableState
